import BackgroundOnHoverWrapper from './BackgroundOnHoverWrapper'

export default BackgroundOnHoverWrapper
